import { Transform, Type } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import {
	PagingSearchFieldArgument,
	PagingSearchFieldArrayArgument,
} from 'src/lib/utilities/api/patterns/pagination/paging-search-field.argument';

export class StudentSearchModel {
	uid: number;
	first_name: string;
	last_name: string;
	middle_name: string;
	suffix_name: string;
	maiden_name: string;
	@Transform(dateTransformer)
	birthdate: Date;
	race: string;
	ethnicity: string;
	gender: string;
	account_email: string;
	active: boolean; // not used in assign table
	has_activated_date: boolean; // being updated to has_activated_date
	reported_grade: string;
	institute_id: number;
	institute_title: string;
	state: string;
	itype: string;
	currently_enrolled: boolean;
}

export function StudentSearchModel_ClassTransform_Type() {
	return StudentSearchModel;
}

export class StudentSearchResponseModel {
	@Type(StudentSearchModel_ClassTransform_Type)
	results: StudentSearchModel[];
	count: number;
}

export interface StudentSearchArgument {
	uid: PagingSearchFieldArgument;
	institute_id: PagingSearchFieldArrayArgument;
	institute_title: PagingSearchFieldArgument;
	state: PagingSearchFieldArgument;
	itype: PagingSearchFieldArgument;
	reported_grade: PagingSearchFieldArgument;
	first_name: PagingSearchFieldArgument;
	last_name: PagingSearchFieldArgument;
	middle_name: PagingSearchFieldArgument;
	suffix_name: PagingSearchFieldArgument;
	maiden_name: PagingSearchFieldArgument;
	birthdate: PagingSearchFieldArgument;
	race: PagingSearchFieldArgument;
	ethnicity: PagingSearchFieldArgument;
	gender: PagingSearchFieldArgument;
	account_email: PagingSearchFieldArgument;
	has_activated_date: PagingSearchFieldArgument;
	currently_enrolled: PagingSearchFieldArgument;
}
